import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import {FaTrashAlt} from "react-icons/fa";
import { useCartContext } from '../../context/cart/cart_context';
import Navbar from './Navbar';

const CartItem = ({cartItem}) => {
  const {removeFromCart, addToCart} = useCartContext();

  return (
    <CartItemWrapper className='grid'>
      <div className='cart-item-img'>
        <img src = '/images/IELTS_general.png'  alt = {cartItem.name} />
      </div>
      <div className='cart-item-info'>
        <p className='fw-7 fs-20'>{cartItem.name}</p>
        {/*<span className='cart-item-creator fs-15 opacity-09'>By {cartItem.creator_name}</span>*/}
        <div className='fw-7 fs-20 text-purple'>{cartItem.test_type_id}</div>
        <div className='cart-item-category bg-orange fs-12 d-inline-block text-capitalize text-white fw-7'>{cartItem.test_type_id}</div>
        <br />
        <div className='cart-item-days fw-7 fs-20'>
        <label htmlFor={`days-input-${cartItem.id}`}>Sessions in package: {cartItem.numberOfDays}</label>
        <input
          type='number'
          id={`days-input-${cartItem.id}`}
          min={1}
        />
      </div>
      <div className='cart-item-total fw-7 fs-20'>
        Total: Rs {cartItem.price}
      </div>
        <button type = "button" className='remove-btn fs-18 text-dark fw-6' onClick={() => removeFromCart(cartItem.id)}>Remove <span><FaTrashAlt /></span></button>
      </div>
    </CartItemWrapper>
  )
}

const CartItemWrapper = styled.div`
  grid-template-columns: 110px auto;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;

  .cart-item-img{
    width: 100px;
    height: 100px;
    overflow: hidden;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .cart-item-category{
    padding: 0px 10px;
    border-radius: 6px;
  }
  .remove-btn{
    margin-top: 16px;
    transition: var(--transition);
    &:hover{
      color: var(--clr-purple);
    }
  }
`;

export default CartItem